import axios, { AxiosResponse } from 'axios';
import type { InternalAxiosRequestConfig } from 'axios';
import authenticationUtils from '../../utils/authenticationUtils';
import routes from '../../constants/routes';

axios.interceptors.response.use(
  (response: AxiosResponse) => {
    return response.data;
  },
  (error) => {
    if (error.response.status === 401) {
      window.location.href = routes.LOGOUT;
      // navigate.push(routes.LOGOUT);
      return;
    }
    throw error.response.data;
  }
);

axios.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  config.headers.Authorization =
    config.headers.Authorization || `Bearer ${authenticationUtils.getToken()}`;
  return config;
});
